// COPIED FROM Backend/src/types/notifications.interface.ts
type ReleaseLabel =
  | 'FEATURE'
  | 'BUGFIX'
  | 'GUI'
  | 'IMPROVEMENT'
  | 'OTHER'
  | 'PERFORMANCE'
  | 'BROKEN LINK TEST'
  | 'COMMON TEST'
  | 'GNB TEST'
  | 'FOOTER TEST';

type GeneralInfoSubCategory = 'KNOWN-ISSUES' | 'NON-ISSUES' | 'FAQ' | 'TIPS' | 'UPDATES' | 'PERFORMANCE' | 'BUGS';

export interface MaintenanceNotification {
  _id: string;
  summary: string;
  title: string;
  createdAt: Date;
  isRead: boolean;
  category: typeof NotificationCategories.MaintenanceNotice;
  startDate: Date;
  expectedEndDate: Date;
  actualEndDate?: Date;
}

export interface ReleaseNotification {
  _id: string;
  summary: string;
  title: string;
  createdAt: Date;
  isRead: boolean;
  category: typeof NotificationCategories.ReleaseNotes;
  contentHtml: string;
  releaseDate: Date;
  labels: ReleaseLabel[];
}

export interface GeneralInformationNotification {
  _id: string;
  summary: string;
  title: string;
  createdAt: Date;
  isRead: boolean;
  category: typeof NotificationCategories.GeneralInformation;
  contentHtml: string;
  releaseDate: Date;
  subCategory: GeneralInfoSubCategory; // only one allowed
}

export type BannedUserNotification = {
  _id: string;
  summary: string;
  title: string;
  createdAt: Date;
  isRead: boolean;
  category: typeof NotificationCategories.BannedUser;
  bannedUser: { _id: string; isBlocked: boolean };
};

// "Notification would be bad name because" there is global type with this name from Notification API
export type TNotification =
  | MaintenanceNotification
  | ReleaseNotification
  | GeneralInformationNotification
  | BannedUserNotification;

export type NotificationWithoutContent =
  | MaintenanceNotification
  | Omit<ReleaseNotification, 'contentHtml'>
  | Omit<GeneralInformationNotification, 'contentHtml'>
  | BannedUserNotification;

export const ConfluenceNotificationCategories = {
  MaintenanceNotice: 'MaintenanceNotice',
  ReleaseNotes: 'ReleaseNotes',
  GeneralInformation: 'GeneralInformation'
} as const;

export const NotificationCategories = {
  ...ConfluenceNotificationCategories,
  BannedUser: 'BannedUser'
} as const;

export type NotificationCategory = (typeof NotificationCategories)[keyof typeof NotificationCategories];
export type ConfluenceNotificationCategory =
  (typeof ConfluenceNotificationCategories)[keyof typeof ConfluenceNotificationCategories];

export enum GeneralInformationSubcategories {
  'KNOWN-ISSUES/BUG' = 'KNOWN-ISSUES/BUG',
  'NON-ISSUE' = 'NON-ISSUE',
  'FAQ/TIP' = 'FAQ/TIP',
  GUIDE = 'GUIDE',
  UPDATE = 'UPDATE',
  PERFORMANCE = 'PERFORMANCE'
}

export enum ReleaseLabels {
  FEATURE = 'FEATURE',
  BUGFIX = 'BUGFIX',
  GUI = 'GUI',
  IMPROVEMENT = 'IMPROVEMENT',
  PERFORMANCE = 'PERFORMANCE',
  'TEST-CASES' = 'BROKEN LINK TEST',
  OTHER = 'OTHER'
}

// PAYLOADS AND RESPONSES
export type GetNotificationsPayload = {
  category?: NotificationCategory;
  isRead?: boolean;
  limit?: number;
};
export type GetNotificationsResponse = Array<NotificationWithoutContent>;

export type GetNotificationResponse = TNotification;
